// File: src/components/Cards/ProductCardWrapper.tsx

import React from "react";
import ProductCard from "./ProductCard";

export const ProductCardWrapper = ({
    product,
    priceSource
}: {
    product: { [key: string]: any };
    onCitationClicked?: (citationFilePath: string) => void;
    priceSource: "web" | "store";
    siteId?: "PUBLIC_GR" | "PUBLIC_CY";
}) => {
    return (
        <div style={{ marginBottom: "24px" }} data-copy-product="true">
            <ProductCard product={product} priceSource={priceSource} />
        </div>
    );
};

export default ProductCardWrapper;
